module.exports = __webpack_public_path__ + "static/img/unposted.0cd37e17.svg";